import React from 'react';

const AppFormInput = ({
  label,
  error,
  hint,
  containerClassName = 'form-control w-full space-y-1 mb-4',
  inputClassName = '',
  className,
  ...rest
}) => {
  return (
    <div className={containerClassName}>
      {label && (
        <label className="label py-1">
          <span className="label-text text-xs font-bold text-slate-700">{label}</span>
        </label>
      )}
      <input
        className={`input input-bordered w-full rounded-xl bg-white border-slate-300 focus:border-[#135A9C] focus:ring-2 focus:ring-[#135A9C]/20 text-sm ${inputClassName} ${className || ''} ${error ? 'input-error' : ''}`}
        {...rest}
      />
      {hint && !error && (
        <label className="label py-1">
          <span className="label-text-alt text-slate-500">{hint}</span>
        </label>
      )}
      {error && <p className="text-error text-xs mt-1">{error}</p>}
    </div>
  );
};

export default AppFormInput;
